import React, { useMemo } from "react";
import AuthProvider from "../../auth/AuthProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";

import { connect } from "react-redux";
import CurrencyProvider from "../../components/Forms/CurrencyProvider";
import useVestigingRelation from "../../components/Forms/useVestigingRelation";
import VestigingProvider from "../../components/Forms/VestigingProvider";
import Algemeen from "./Tabs/Algemeen";
import { formatTitle } from "../../../utils/formatting";
import { Link } from "react-router";

function PrinterForm(props) {
  const endPoint = useMemo(() => {
    return "core/printers";
  }, []);

  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });

  return (
    <AuthProvider guardMode={false} prefix={"printers"}>
      <CurrencyProvider currency={currency}>
        <VestigingProvider vestiging={vestiging}>
          <JamezzFormV2
            computedPageTitle={function (model) {
              return formatTitle(this.pageTitle, model.name);
            }}
            endPoint={endPoint}
            extraFields={extraFields}
            extraFormProps={{ vestiging, vestigingId: vestiging?.id, menukaartVestigingId }}
            mode={"onSubmit"}
            onGetModel={onGetModel}
            pageTitle={getTranslation("printers.form.pageTitle", "Printers")}
            pageTitleSubject={
              <small>
                <Link to={`/manager/vestigingen/${vestiging?.id}/edit`}>{vestiging?.naam}</Link> - {vestiging?.id}
              </small>
            }
            parseInput={{}}
            revalidateMode={"onChange"}
            rootRight={"printers"}
            tabs={[
              {
                right: "algemeen",
                tabButton: <TranslationWrapper tDefault={"Algemeen"} tKey={"printers.form.tabs.algemeen"} />,
                tabContent: <Algemeen />,
              },
            ]}
          />
        </VestigingProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(PrinterForm);
